import { render, staticRenderFns } from "./SearchTestForm.vue?vue&type=template&id=23443bd2&"
import script from "./SearchTestForm.vue?vue&type=script&lang=js&"
export * from "./SearchTestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports